import { useGetMessagesQuery } from "../app/api-slice";
import { useAppSelector } from "../app/hooks";
import { sessionIdSelector, useDataRequestLang } from "../app/main-slice";

export const useMessages2 = () => {
    const lang = useDataRequestLang();
    const sessionId = useAppSelector(sessionIdSelector);

    const { data, ...rest } = useGetMessagesQuery({ lang, sessionId: sessionId! }, { skip: !sessionId });
    return { messages: data, ...rest };
}